import iconSrc from "~/assets/images/desktop/pending-img.svg";

const AppointmentPending = () => {
  return <div>
    <div className="text-center pb-4 appointment-result">
      <p className="mb-4 footer-box-text">You can use this link to check status or contact your scheduler</p>
      <img className="pending-icon" src={iconSrc}></img>
      <h5 className="mt-4 appointment-card-title">Pending Appointment</h5>
      <div className="mt-2 pending-appointment-paragraph mt-4 mb-4">A notary will be in contact to set a signing appointment within 24 hours after the documents are delivered to the notary. Thank you!</div>
    </div>
  </div>
};

export default AppointmentPending;